import { Export } from "@dto/pageResponse.dto";
import XmExportIcon from "src/component/apiDownloader/XmExportIcon";

interface XmExportContentIconProps {
  exportProp: Export;
}

const XmExportContentIcon = ({ exportProp }: XmExportContentIconProps) => {
  return (
    <div className="export-content-icon-wrapper">
      <XmExportIcon exportableTypes={{ XLSX: false, JSON: false, CSV: false }} export={exportProp} />
    </div>
  );
}

export default XmExportContentIcon;